import React from "react";
import { useNavigate } from "react-router-dom";

const CategoriasScroll = ({ data }) => {
  const navigate = useNavigate();

  if (!data || !data.comercios || data.comercios.length === 0) return null;

  return (
    <div className="categorias-scroll">
      <div className="filtro-label">
        {data.titulo}
      </div>
      <div className="filtros-lista">
        {data.comercios.map((comercio) => (
          <button
            key={comercio.id_sucursal}
            className="filtro-btn"
            aria-label={comercio.nombre_sucursal}
            onClick={() =>
              navigate(`/comercio/app/${comercio.id_sucursal}`, {
                state: { from: "home" },
              })
            }
          >
            <img
              src={comercio.logo || "/assets/images/default.png"}
              alt={comercio.nombre_sucursal}
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/default.png";
              }}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoriasScroll;
